import {
  CashBreakInfo,
  CashBreakSuggestion,
  CwTransactionSuggestion,
  ExtTransactionSuggestion,
} from './../models/copilot.model'
/**
 * Generates a markdown string for displaying the first cash break solution available with a message and table(s).
 */
export function generateMarkdown(
  results: CashBreakSuggestion[],
  cashBreak: CashBreakInfo,
): string {
  if (results.length == 0) {
    const msg = `There were no solutions found for the cash difference break in account ${cashBreak.accountId} for assetId ${cashBreak.assetId}.`
    return msg
  }
  let msg = `There are ${results.length} solution(s) found for the cash difference break in account ${cashBreak.accountId} for assetId ${cashBreak.assetId}.\n > :warning: **Please note: This is an experimental feature.** Make sure to verify the presented solution before applying it\n\n`
  const result = results[0] // Get only the first object of the array response

  const generateCwTranTable = (
    title: string,
    tranSuggestions: CwTransactionSuggestion[],
  ) => {
    msg += `## ${title}\n\n| TranId | AccountId | AssetId | Post Date | Amount | Currency |\n|--------|-----------|------------|---------------|----------|----------|\n`
    tranSuggestions.forEach(tran => {
      msg += `| ${tran.tranId} | ${tran.accountId} | ${tran.secIdentifier} | ${tran.postDate} | ${tran.amount} | ${tran.currencyCode} |\n`
    })
    msg += '\n'
  }

  const generateExtTranTable = (
    title: string,
    tranSuggestions: ExtTransactionSuggestion[],
  ) => {
    msg += `## ${title}\n\n| TranId | AccountId | AssetId | Post Date | Amount | Currency |\n|--------|-----------|------------|---------------|----------|----------|\n`
    tranSuggestions.forEach(tran => {
      msg += `| ${tran.extTranId} | ${tran.accountId} | ${tran.secIdentifier} | ${tran.postDate} | ${tran.amount} | ${tran.currencyCode} |\n`
    })
    msg += '\n'
  }

  if (result.cwTranToClear.length > 0)
    generateCwTranTable(
      'Clearwater Transactions to Clear',
      result.cwTranToClear,
    )
  if (result.cwTranToUnclear.length > 0)
    generateCwTranTable(
      'Clearwater Transactions to Unclear',
      result.cwTranToUnclear,
    )
  if (result.extTranToClear.length > 0)
    generateExtTranTable(
      'External Transactions to Process',
      result.extTranToClear,
    )

  return msg
}
